import {
	ApplicationState,
	SET_APP_VIEW,
	SET_CURRENT_LIGHTBOX,
	SET_DEFAULT_APPLICATION,
	SWIPE_IN_MODULE_SWIPER,
	APP_INIT,
	SET_LANGUAGE_CHANGED,
	SET_HAS_FIRST_INTERACTION_HAPPENED,
	SET_BROWSER_IS_DETECTED,
	SET_LOADING_MODELS,
	SET_ASSET_FOLDER,
	SHOW_DEBUG,
	SET_USE_INDIVIDUAL_ASSETS,
	SET_HAS_VISIT_SCENE,
	SET_COVER_CHANGED,
	SET_LOADING_COVERS,
	SET_SHOW_FAKE_DATA_FORM,
	SET_FAKE_DATA,
	SET_SHOW_IPEX_GALLERY_BUTTON,
	SET_FOOTER_HEIGHT,
	SET_HEADER_HEIGHT,
	SET_PRODUCT_VARIANTS_SHOW_MORE,
	SET_IDLE_TIME,
	SET_IS_IN_UPPTACKA_PLATFORM,
	SET_DISABLE_BULK_FETCH,
	SET_INSIGHTS_INITIATED,
	SET_USE_PERSISTED_CONFIG,
	SET_TOTAL_PRICE_VOICE,
} from './types';
import { Actions } from '..';
import {
	SET_SHOW_FUNCTION_SLEEP,
	SET_SHOW_FUNCTION_STORAGE,
	SET_SHOW_MEASUREMENTS,
} from '../actionButtons';

const initialState: ApplicationState = {
	assetFolder: null,
	appInitialized: false,
	appView: 'build-view',
	currentLightbox: 'product-intro-gallery',
	hasFirstInteractionHappened: false,
	browserIsDetected: false,
	languageChanged: null,
	coverChanged: null,
	loadingModels: false,
	loadingCovers: false,
	useIndividualAssets: false,
	hasVisitScene: false,
	fakeData: null,
	showIpexGalleryButton: false,
	productVariantsShowMore: false,
	idleTime: null,
	isInUpptackaPlatform: false,
	disableBulkFetch: false,
	insightsInitiated: false,
	usePersistedConfig: false,
	totalPriceVoice: null,
};

export function applicationReducer(state = initialState, action: Actions): ApplicationState {
	switch (action.type) {
		case APP_INIT:
			return { ...state, appInitialized: true };
		case SET_APP_VIEW:
			if (action.value === 'summary-page') {
				return { ...state, appView: action.value, hasFirstInteractionHappened: true };
			}
			return { ...state, appView: action.value };
		case SET_CURRENT_LIGHTBOX:
			if (action.value === 'product-intro-gallery') {
				return { ...state, currentLightbox: action.value, hasFirstInteractionHappened: true };
			}
			return { ...state, currentLightbox: action.value };
		case SET_DEFAULT_APPLICATION: {
			return { ...state, defaultApplication: action.value };
		}
		case SET_SHOW_FUNCTION_SLEEP:
		case SET_SHOW_FUNCTION_STORAGE: {
			return { ...state, hasFirstInteractionHappened: true };
		}
		case SET_SHOW_MEASUREMENTS: {
			return { ...state, hasFirstInteractionHappened: true };
		}
		case SWIPE_IN_MODULE_SWIPER: {
			return { ...state, hasFirstInteractionHappened: true };
		}
		case SET_HAS_FIRST_INTERACTION_HAPPENED: {
			return { ...state, hasFirstInteractionHappened: action.value };
		}
		case SET_BROWSER_IS_DETECTED: {
			return { ...state, browserIsDetected: action.value };
		}
		case SET_LANGUAGE_CHANGED: {
			return { ...state, languageChanged: action.value };
		}
		case SET_COVER_CHANGED: {
			return { ...state, coverChanged: action.value };
		}
		case SET_LOADING_MODELS:
			return { ...state, loadingModels: action.value };
		case SET_LOADING_COVERS:
			return { ...state, loadingCovers: action.value };
		case SET_ASSET_FOLDER:
			return { ...state, assetFolder: action.name };
		case SHOW_DEBUG:
			return { ...state, showDebug: action.value };
		case SET_USE_INDIVIDUAL_ASSETS:
			return { ...state, useIndividualAssets: action.value };
		case SET_HAS_VISIT_SCENE:
			return { ...state, hasVisitScene: action.value };
		case SET_SHOW_FAKE_DATA_FORM:
			return { ...state, showFakeDataForm: action.value };
		case SET_FAKE_DATA:
			return { ...state, fakeData: action.value };
		case SET_SHOW_IPEX_GALLERY_BUTTON:
			return { ...state, showIpexGalleryButton: action.value };
		case SET_IDLE_TIME:
			return { ...state, idleTime: action.value };
		case SET_IS_IN_UPPTACKA_PLATFORM:
			return { ...state, isInUpptackaPlatform: action.value };
		case SET_FOOTER_HEIGHT:
			return { ...state, footerHeight: action.value };
		case SET_HEADER_HEIGHT:
			return { ...state, headerHeight: action.value };
		case SET_PRODUCT_VARIANTS_SHOW_MORE:
			return { ...state, productVariantsShowMore: action.value };
		case SET_DISABLE_BULK_FETCH:
			return { ...state, disableBulkFetch: action.value };
		case SET_INSIGHTS_INITIATED:
			return { ...state, insightsInitiated: action.value };
		case SET_USE_PERSISTED_CONFIG:
			return { ...state, usePersistedConfig: action.value };
		case SET_TOTAL_PRICE_VOICE:
			return { ...state, totalPriceVoice: action.value };
		default:
			return state;
	}
}
